/**
 * Footer.js — now a proxy to the Apple/Linear-inspired PremiumFooter.
 * Every page that used the old <Footer /> automatically gets the new design.
 * Original legacy footer preserved at Footer.legacy.js for reference.
 */
import PremiumFooter from "@/components/premium/PremiumFooter";

export default function Footer(props) {
  return <PremiumFooter {...props} />;
}
